import "./TitleBlock.scss";

export const TitleBlock = () => {
  return (
    <article className="titleBlock">
      <h2 className="titleBlock__title">
        <span>TUTORIFY</span> is a meeting place for tutors and students
      </h2>
      <p className="titleBlock__text">
        <span>Tutorify</span> is a platform where everyone can find a private
        tutor according to their criteria, and tutors get new clients
      </p>
    </article>
  );
};
